import * as React from 'react';
import ReactPlayer from 'react-player';
import { CloseSquareIcon, PlayIcon, VideoPlayIcon } from 'assets/icons';
import { IconButton } from '@mui/material';
import './styles.scss';

interface VideoProps {
  url: string;
  light?: string | boolean;
  onRemove?: () => void;
}
const VideoPreviewPlayer = ({ url, light, onRemove }: VideoProps) => {
  const [playing, setPlaying] = React.useState(false);
  return (
    <div className="player-wrapper w-100">
      <ReactPlayer
        className="react-player"
        url={url}
        light={light}
        width="100%"
        height="100%"
        playsinline
        playIcon={<PlayIcon />}
        playing={playing}
        onPause={() => setPlaying(false)}
        onEnded={() => setPlaying(false)}
        onPlay={() => setPlaying(true)}
        controls={playing}
        onSeek={() => setPlaying(true)}
      />
      {onRemove && (
      <div className="videoRemoveIcon">
        <IconButton
          sx={{
            padding: 0,
            borderRadius: 0,
          }}
          onClick={onRemove}
        >
          <CloseSquareIcon
            sx={{
              fontSize: 30, color: 'background.paper', borderRadius: '50%', backgroundColor: '#00000036',
            }}
          />
        </IconButton>
      </div>
      )}
      <div className={`playIcon ${playing ? 'd-none' : 'd-flex w-100 h-100'}`}>
        <IconButton
          sx={{
            padding: 0,
            borderRadius: 0,
          }}
          onClick={() => setPlaying(true)}
          className="w-100 h-100"
        >
          <VideoPlayIcon
            sx={{
              fontSize: 30, color: 'background.paper', borderRadius: '50%', backgroundColor: '#00000036',
            }}
          />
        </IconButton>
      </div>
    </div>
  );
};

VideoPreviewPlayer.defaultProps = {
  light: false,
  onRemove: undefined,
};

export default VideoPreviewPlayer;
